import React from 'react'
import { Accordion } from 'react-bootstrap'

const FaqAccordion = () => {
    function convertToPersianNumbers(input) {
        const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
        return input.replace(/\d/g, (digit) => persianDigits[digit]);
      }
    return (
        <Accordion >
            <div className='flex flex-wrap [&>div]:!px-0 [&_.accordion-outer]:p-1'>
                <div className='col-sm-12 col-md-6 col-lg-6'>
                    <div className='accordion-outer'>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>آیا برای خرید از فروشگاه آنلاین کادونا، حتما باید در سایت عضو باشم؟</Accordion.Header>
                            <Accordion.Body>
                                بله، با این که بدون وارد شدن به سایت می توانید یک کالا را به سبد خرید اضافه کنید، اما برای انجام مراحل بعدی خرید و ثبت سفارش باید با حساب کاربری خود وارد سایت شده و یا در هنگام خرید، عضویت خود را تکمیل نمایید.
                            </Accordion.Body>
                        </Accordion.Item>
                    </div>
                    <div className='accordion-outer'>
                        <Accordion.Item eventKey="1">
                            <Accordion.Header>آیا در تمام ساعات شبانه روز می‌توانم سفارش خود را ثبت کنم؟</Accordion.Header>
                            <Accordion.Body>{
                                
                            convertToPersianNumbers( 'شما در 24 ساعت شبانه روز و 7 روز هفته می توانید سفارش خود را ثبت کنید.')
                                }
                               
                            </Accordion.Body>
                        </Accordion.Item>
                    </div>
                    <div className='accordion-outer'>
                        <Accordion.Item eventKey="2">
                            <Accordion.Header>ممکن است پرداخت اینترنتی ناموفق باشد، ولی مبلغ از حساب من کم شده باشد؟</Accordion.Header>
                            <Accordion.Body>
                                گاهی ممکن است در هنگام پرداخت شبکه بانکی قطع شود و پرداخت ناموفق انجام شود. اما در این مواقع جای نگرانی وجود ندارد. در این حالت معمولا پول شما در حساب های میانی بانک است و خود بانک مغایرت ها را رفع کرده و مبلغ را به صورت خودکار به حساب شما برگشت می دهد. اگر تا 72 ساعت پول به حسابتان برگشت نخورد، آنگاه با بانک عامل پرداخت اینترنتی تماس بگیرید تا مغایرت برطرف شود.                </Accordion.Body>
                        </Accordion.Item>
                    </div>
                    <div className='accordion-outer'>
                        <Accordion.Item eventKey="3">
                            <Accordion.Header className='text-end'>سفارش خود را به چه روش هایی می توانم تحویل بگیرم؟</Accordion.Header>
                            <Accordion.Body>
                                سفارش ها از طریق شرکت پست در سرتاسر کشور ارسال می‌شوند.
                            </Accordion.Body>
                        </Accordion.Item>
                    </div>
                 
                    <div className='accordion-outer'>
                        <Accordion.Item eventKey="4">
                            <Accordion.Header className='text-end'>رمز کارت کجا درج شده؟</Accordion.Header>
                            <Accordion.Body>
برای ایمنی و راحتی کاربر، رمز کارت بر روی مقوای بسته بندی کادونا و دقیقا در زیر محل قرار گیری کارت درج شده است.
<br />
با باز کردن بسته برای دسترسی به کارت، رمز شما در زیر محل قرار گیری کارت نمایان می شود.  
                          </Accordion.Body>
                        </Accordion.Item>
                    </div>
                 
                 
                </div>

                <div className='col-sm-12 col-md-6 col-lg-6 '>
                    <div className='accordion-outer'>
                        <Accordion.Item eventKey="15">
                            <Accordion.Header> سفارش من پس از ثبت، به سرعت ارسال می‌شود؟</Accordion.Header>
                            <Accordion.Body>
                                {
                                    convertToPersianNumbers('آماده سازی بستگی به نوع سفارش شما دارد و بین 24  تا 72 ساعت کاری برای شما ارسال می گردد.')
                                }
                            </Accordion.Body>
                        </Accordion.Item>
                    </div>
                    <div className='accordion-outer'>
                        <Accordion.Item eventKey="16">
                            <Accordion.Header>سفارش ها چه زمانی به پست تحویل داده می شود؟</Accordion.Header>
                            <Accordion.Body>
                             سفارش ها پس از طی مراحل پردازش، تحویل پست می‌شود.
                            </Accordion.Body>
                        </Accordion.Item>
                    </div>
                    <div className='accordion-outer'>
                        <Accordion.Item eventKey="17">
                            <Accordion.Header>کادونا پس از شارژ، بلافاصله قابل استفاده است؟</Accordion.Header>
                            <Accordion.Body>{
                                convertToPersianNumbers('48 ساعت پس از شارژ کارت هدیه کادونا،فعال شده و می توان از آن استفاده کرد.')}
                                 
                            </Accordion.Body>
                        </Accordion.Item>
                    </div>
                    <div className='accordion-outer'>
                        <Accordion.Item eventKey="18">
                            <Accordion.Header> با استفاده از کارت کدام بانک ها می توان هزینه سفارش را اینترنتی پرداخت کرد؟</Accordion.Header>
                            <Accordion.Body>
                                شما می توانید با استفاده از همه کارت های بانکی عضو شبکه شتاب در سایت فروشگاه آنلاین کادونا، هزینه سفارش را به صورت آنلاین پرداخت کنید.                </Accordion.Body>
                        </Accordion.Item>
                    </div>
                    <div className='accordion-outer'>
                        <Accordion.Item eventKey="19">
                            <Accordion.Header> هنگام شارژ به چه نکاتی باید توجه کرد؟</Accordion.Header>
                            <Accordion.Body>
                                <p>1. دقت فرمایید شماره کارت را درست وارد کنید </p>
                                <p>2. توجه داشته باشید، کارت یکبار قابل شارژاست، بنابراین پیش از شارژ در مورد مبلغ هدیه تصمیم بگیرید</p>
                                <p>3. دقت فرمایید که مبلغ شارژ را درست وارد نمایید. زیرا پس از یکبار شارژ امکان افزایش موجودی ممکن نیست </p>
                                </Accordion.Body>
                        </Accordion.Item>
                    </div>
                </div>
            </div>
        </Accordion>
    )
}

export default FaqAccordion
